import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { Params, Router } from '@angular/router';

import { SharedModule } from '../../../shared.module';

@Component({
  selector: 'app-widget-number-display',
  templateUrl: './widget-number-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SharedModule],
})
export class WidgetNumberDisplayComponent {
  @Input() navigateOnClick: boolean = false;

  @Input() hyperlink: string | null = null;

  @Input() queryParams: Params | null = null;

  @Input() loading: boolean = true;

  @Input() ctaText: string = '';

  @Input() status: string = '';

  @Input() number: number = 0;

  @Input() title: string = '';

  @Input() label: string = '';

  @Input() icon: string = '';

  private readonly router$ = inject(Router);

  @HostListener('click') onClick(): void {
    this.navigate();
  }

  @HostListener('keydown.enter', ['$event'])
  @HostListener('keydown.space', ['$event'])
  onKeydown(event: Event): void {
    if (!this.canNavigate()) return;
    event.preventDefault();
    this.navigate();
  }

  private navigate(): void {
    if (!this.canNavigate()) return;
    this.router$.navigate([this.hyperlink], {
      queryParams: this.queryParams ?? undefined,
    });
  }

  get isCardNavigable(): boolean {
    return this.canNavigate();
  }

  get accessibleLabel(): string {
    return [this.label, `${this.number || 0}`, this.ctaText]
      .filter(Boolean)
      .join(', ');
  }

  private canNavigate(): boolean {
    if (!this.hyperlink) return false;
    if (!this.navigateOnClick || this.loading) return false;
    return true;
  }
}
